<div class="row row--primary">
  <bezugsrecht-back-link (back)="back()" label="bezugsrecht-page.bezugsrecht-sell.link-back" />
  @if (model?.announcement) {
    <div class="tile">
      <div class="col-12 mt-2 opacity-container" [class.active]="model.announcement">
        <div class="row">
          <div class="col-12">
            <h5
              [innerHTML]="
                'bezugsrecht-page.bezugsrecht-sell.title'
                  | transloco
                    : {
                        name: model.announcement.bzrBezeichnung,
                        isin: model.announcement.bzrIsin,
                      }
              "
            >
              &nbsp;
            </h5>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-12 mb-2">
            <div class="row mb-4">
              <div
                class="col-12"
                [innerHTML]="
                  'bezugsrecht-page.bezugsrecht-sell.hint'
                    | transloco
                      : {
                          name: model.announcement.bzrBezeichnung,
                          isin: model.announcement.bzrIsin,
                          underlyingName: model.announcement.bezugAktieBezeichnung,
                          underlyingIsin: model.announcement.bezugAktieIsin,
                          buyableAmount: model.buyableAmount | number: '1.0-0',
                        }
                "
              ></div>
            </div>
            <div class="row d-flex align-items-center">
              <div class="col-lg-6 text-center text-lg-left">
                <web-design-system-button
                  (click)="openSellNewTab()"
                  size="small"
                  [fullwidth]="true"
                  [disabled]="!model.announcement.bzrHandelbarBroker"
                >
                  {{ 'bezugsrecht-page.bezugsrecht-sell.link-submit' | transloco | uppercase }}
                </web-design-system-button>
                @if (!model.announcement.bzrHandelbarBroker) {
                  <div class="font-size-smaller2 text-center">
                    {{ 'bezugsrecht-page.bezugsrecht-sell.not-tradable-hint' | transloco }}
                  </div>
                }
              </div>
              <div class="col-lg-6 text-center text-lg-left mt-2 mt-lg-0">
                <a [routerLink]="commonRoutes.postlogin.member_home" class="link-secondary font-default"
                  >{{ 'bezugsrecht-page.bezugsrecht-sell.link-wait' | transloco }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
</div>
